export default "__VITE_ASSET__Cl_QrA$X__"